import React from 'react';
import PropTypes from 'prop-types';

const INSERT_ITEM_ID = 'INSERT_ITEM_ID';

/**
 * TransilluminatorConrols:
 *  - The layer over the Transilluminator image
 *    Used to  handle click event on transilluminator lid and controls panel area
 */
export function TransilluminatorControls(props) {
  let lidBlockPosition = {height: '100px', top: '63px'};

  if (props.open) {
    lidBlockPosition = {
      height: '157px',
      top: '2px',
    };
  }

  const onClick = (callback) => (event) => {
    event.stopPropagation();
    callback();
  };

  const onDragOver = (event) => event.preventDefault();

  const onDrop = (event) => {
    const insertItemId = parseInt(event.dataTransfer.getData(INSERT_ITEM_ID));
    props.onInsertItem({
      itemId: insertItemId,
    });
  };

  const renderDropZone = () => {
    return (
      props.isOpen && (
        <div
          className='transilluminator_mouth'
          onDragOver={onDragOver}
          onDrop={onDrop}
          onClick={onClick(props.openTransilluminatorControlsModal)}>
        </div>
      )
    );
  };

  return (
    <>
      <div
        className='transilluminator_lidblock'
        onClick={onClick(props.toggleLid)}
        style={lidBlockPosition}
      />
      {renderDropZone()}
    </>
  );
}

TransilluminatorControls.propTypes = {
  /**
   * Boolean to set if lid is open/closed
   */
  open: PropTypes.bool,
  /**
   * Function to invoke to open/close lid
   */
  toggleLid: PropTypes.func,
  /**
   * Function to invoke to open digital controls panel
   */
  openControls: PropTypes.func,
  /**
   * Function to invoke when an item is dropped into the transilluminator
   */
  onInsertItem: PropTypes.func,
  /**
   * Function to invoke open the balancing modal window
   */
  openTransilluminatorControlsModal: PropTypes.func
};

TransilluminatorControls.defaultProps = {};
